import { myDriveKeys } from './constants'

import { createEventEmitter } from '../event'

export const myDriveEventEmitter = createEventEmitter()

export const emitToggleMyDrive = value => {
    myDriveEventEmitter.emit(myDriveKeys.OPEN_MY_DRIVE, value)
}

export const emitToggleQuiz = () => {
    myDriveEventEmitter.emit(myDriveKeys.TOGGLE_QUIZ)
}
